export function deleteTooltip(isSharedExternally: boolean, hasExecution: boolean) {
  if ((isSharedExternally && hasExecution) || (!isSharedExternally && hasExecution)) {
    return 'This simulation has been sent to the lab and cannot be deleted';
  } else if (isSharedExternally && !hasExecution) {
    return 'This simulation has been shared and cannot be deleted';
  }
  return 'Delete Simulation';
}
